export default {
  priv: 'pr_transportvouchers',
  overviewTitle: 'Bonnen',
  detailTitle: 'Bon',
  deleteTitle: 'deze bon',
  url: '/transportvouchers',
  apiUrl: '/transportvouchers/',
  sortBy: ['id'],
  sortDesc: [true],
  deletable: false,
  editable: true,
  filterName: 'transportvouchers',
  defaultPerPage: 100,
  quickFilter: {
    text: 'Zoek op dossiernummer',
    value: 'order_number1',
    type: 'text'
  },
  advancedSearchFields: [
    {text: 'Opdrachtgever', value: 'ordering_customer_id', type: 'optionList', optionListName: 'customers', optionListParams: {is_transportvoucher_ordering_customer: true}},
    {text: 'Chauffeur', value: 'user_id', type: 'optionList', optionListName: 'users'},
    {text: 'Periode van', value: 'order_date_ge', type: 'date'},
    {text: 'Periode tot', value: 'order_date_le', type: 'date'}
  ],
  newRecord: {
    is_active: true
  },
  eventFieldName: 'transportvouchereventtype_id',
  lastEventFieldName: 'last_transportvouchereventtype_id',
  eventMap: [
    {value: null, text: 'Toon alle'},
    {value: 1, text: 'Email verstuurd', color: 'green'},
    {value: 2, text: 'Afgesloten', color: 'orange'}
  ],
  tableFields: [
    {text: 'Bon', value: 'id', link: '/transportvouchers/{id}', width: '5%'},
    // {text: 'Gebruiker', value: 'user_full_name', width: '2%' , filter: 'shortname2'},
    {text: 'CRD', value: 'coordinator', width: '3%', filter: 'shortname2', access: 'manager'},
    {text: 'Beg1', value: 'responsible1', width: '3%', filter: 'shortname2', access: 'manager'},
    {text: 'Beg2', value: 'responsible2', width: '3%', filter: 'shortname2', access: 'manager'},
    {text: 'Beg3', value: 'responsible3', width: '3%', filter: 'shortname2', access: 'manager'},
    {text: 'Datum', value: 'order_date', filter: 'date', width: '6%'},
    {text: 'Vertrek Bureel', value: 'office_departure_time', filter: 'time', width: '4%'},
    {text: 'Vertrek Begeleiding', value: 'pilot_departure_time', filter: 'time', width: '4%'},
    {text: 'Aankomst Begeleiding', value: 'pilot_arrival_time', filter: 'time', width: '4%'},
    {text: 'Aankomst Bureel', value: 'office_arrival_time', filter: 'time', width: '4%'},
    {text: 'Tijd', value: 'office_time_duration', width: '4%'},
    {text: 'Opdrachtgever', value: 'ordering_customer_name', width: '5%'},
    {text: 'Transporteur', value: 'final_customer_name', width: '5%'},
    {text: 'Van', value: 'address_from', width: '5%'},
    {text: 'Naar', value: 'address_to', width: '5%'},
    // {text: 'Dossiernummer1', value: 'order_number1', width: '10%'},
    {text: 'Bestand', value: 'file', type: 'file', width: '5%', align: 'center', sortable: false, access: 'manager|dispatch'}
  ],
  customEditable(item, user) {
    // console.log('customEditable', item, user);
    if (user) {
      const userroleId = user.userrole_id;
      if (userroleId === 1) { // super
        return true;
      } else if (userroleId === 2) { // manager
        return true;
      } else if (userroleId === 3) { // dispatch
        return !item.is_locked;
      } else if (userroleId === 4 || userroleId === 5) { // driver,pilot
        // console.log('customEditable', item.created_user_id, user.id, item.is_locked, item.is_closed);
        if (item.created_user_id && (item.created_user_id !== user.id)) {
          return false;
        }
        return !item.is_locked && !item.is_closed;
      }
    }
    return false;
  },
  customDeletable(item, user) {
    // console.log('customEditable', item, user);
    if (user) {
      const userroleId = user.userrole_id;
      if (userroleId === 1) { // super
        return true;
      } else if (userroleId === 2 || userroleId === 3) { // manager,dispatch
        return !item.is_locked;
      } else if (userroleId === 4 || userroleId === 5) { // driver,pilot
        // console.log(item.created_user_id, user.id);
        if (item.created_user_id !== user.id) {
          return false;
        }
        return !item.is_locked && !item.is_closed;
      }
    }
    return false;
  }
};
